module.exports = __webpack_public_path__ + "static/media/team_photo.cbf5d0ec.png";